export interface EventAttendee {
  eventAttendeeId: number,
  questionnaireId: number,
  eventId: number,
  isAttending: boolean,
  prefix: string,
  firstName: string,
  lastName: string,
  title: string,
  emailAddress: string,
  primaryLanguage: string,
  dietaryRequests: string,
  accessibilityNeeds: string,
  timeZone: string,
}

export const maxAttendeesInEvent = 2;

export function blankEventAttendee(eventId: number, questionnaireId: number): EventAttendee {
  return {
    eventAttendeeId: 0,
    questionnaireId,
    eventId,
    isAttending: false,
    prefix: '',
    firstName: '',
    lastName: '',
    title: '',
    emailAddress: '',
    primaryLanguage: '',
    dietaryRequests: '',
    accessibilityNeeds: '',
    timeZone:'',
  }
}

export function copyEventAttendee(eventAttendee: EventAttendee): EventAttendee {
  return {
    eventAttendeeId: eventAttendee.eventAttendeeId,
    questionnaireId: eventAttendee.questionnaireId,
    eventId: eventAttendee.eventId,
    isAttending: eventAttendee.isAttending,
    prefix: eventAttendee.prefix,
    firstName: eventAttendee.firstName,
    lastName: eventAttendee.lastName,
    title: eventAttendee.title,
    emailAddress: eventAttendee.emailAddress,
    primaryLanguage: eventAttendee.primaryLanguage,
    dietaryRequests: eventAttendee.dietaryRequests,
    accessibilityNeeds: eventAttendee.accessibilityNeeds,
    timeZone: eventAttendee.timeZone,
  }
}
